import React from "react";
import {
  GOVGR_ERROR_MESSAGE,
  GOVGR_VISUALLY_HIDDEN,
} from "../../conf/styles/GovGrSelect";
import { WRONG_TEXT } from "./constants";

const ErrorMessage = ({ errorMessage }) => {
  return (
    <p className={`${GOVGR_ERROR_MESSAGE} mt-2`}>
      <span className={`${GOVGR_VISUALLY_HIDDEN}`}>{WRONG_TEXT}:</span>
      {errorMessage}
    </p>
  );
};

export default ErrorMessage;
